angular.module('qkr').controller('SessionExpiryController', sessionExpiryController);

sessionExpiryController.$inject = ['sessionExpiryService', '$uibModalInstance', '$interval', 'appConfig'];

function sessionExpiryController(sessionExpiryService, $uibModalInstance, $interval, appConfig) {
    const vm = this;

    // countdown will finish by this time
    const countdownFinishDate = new Date(new Date().getTime() + appConfig.sessionCountdownMillis);

    vm.continueSession = function() {
        sessionExpiryService.continueSession();
        $interval.cancel(promiseIntervalResponse);
        $uibModalInstance.close(true);
    };

    vm.logoutUser = function() {
        sessionExpiryService.logout();
    };

    function updateTimeRemaining() {
        const now = new Date();
        const timeRemainingMillis = countdownFinishDate - now;

        vm.timeRemaining = timeRemainingMillis > 0;

        vm.minutes = Math.floor((timeRemainingMillis % (1000 * 60 * 60)) / (1000 * 60));
        vm.seconds = Math.floor((timeRemainingMillis % (1000 * 60)) / 1000);

        if (!vm.timeRemaining) {
            $interval.cancel(promiseIntervalResponse);
        }
    }

    updateTimeRemaining();

    const promiseIntervalResponse = $interval(updateTimeRemaining, 1000);
}



// WEBPACK FOOTER //
// ./src/sessionExpiry/controllers/session.expiry.controller.js